// NGRX
import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { ScopeModel } from '../_models/scope.model';

export enum ScopeActionTypes {
    ScopeOnServerCreated = '[Edit Scope Dialog] Scope On Server Created',
    ScopeCreated = '[Edit Scope Dialog] Scope Created',
    ScopeUpdated = '[Edit Scope Dialog] Scope Updated',
    ScopesStatusUpdated = '[Scope List Page] Scopes Status Updated',
    OneScopeDeleted = '[Scopes List Page] One Scope Deleted',
    ManyScopesDeleted = '[Scopes List Page] Many Scope Deleted',
    ScopesPageRequested = '[Scopes List Page] Scopes Page Requested',
    ScopesPageLoaded = '[Scopes API] Scopes Page Loaded',
    ScopesPageCancelled = '[Scopes API] Scopes Page Cancelled',
    ScopesPageToggleLoading = '[Scopes] Scopes Page Toggle Loading',
    ScopeActionToggleLoading = '[Scopes] Scopes Action Toggle Loading'
}

export class ScopeOnServerCreated implements Action {
    readonly type = ScopeActionTypes.ScopeOnServerCreated;
    constructor(public payload: { scope: ScopeModel }) { }
}

export class ScopeCreated implements Action {
    readonly type = ScopeActionTypes.ScopeCreated;
    constructor(public payload: { scope: ScopeModel }) { }
}

export class ScopeUpdated implements Action {
    readonly type = ScopeActionTypes.ScopeUpdated;
    constructor(public payload: {
        partialScope: Update<ScopeModel>, // For State update
        scope: ScopeModel // For Server update (through service)
    }) { }
}

export class ScopesStatusUpdated implements Action {
    readonly type = ScopeActionTypes.ScopesStatusUpdated;
    constructor(public payload: {
        scopes: ScopeModel[],
        status: number
    }) { }
}

export class OneScopeDeleted implements Action {
    readonly type = ScopeActionTypes.OneScopeDeleted;
    constructor(public payload: { id: number }) {}
}

export class ManyScopesDeleted implements Action {
    readonly type = ScopeActionTypes.ManyScopesDeleted;
    constructor(public payload: { ids: number[] }) {}
}

export class ScopesPageRequested implements Action {
    readonly type = ScopeActionTypes.ScopesPageRequested;
    constructor(public payload: { page: QueryParamsModel }) { }
}

export class ScopesPageLoaded implements Action {
    readonly type = ScopeActionTypes.ScopesPageLoaded;
    constructor(public payload: { scopes: ScopeModel[], totalCount: number, page: QueryParamsModel }) { }
}

export class ScopesPageCancelled implements Action {
    readonly type = ScopeActionTypes.ScopesPageCancelled;
}

export class ScopesPageToggleLoading implements Action {
    readonly type = ScopeActionTypes.ScopesPageToggleLoading;
    constructor(public payload: { isLoading: boolean }) { }
}

export class ScopeActionToggleLoading implements Action {
    readonly type = ScopeActionTypes.ScopeActionToggleLoading;
    constructor(public payload: { isLoading: boolean }) { }
}

export type ScopeActions = ScopeOnServerCreated
| ScopeCreated
| ScopeUpdated
| ScopesStatusUpdated
| OneScopeDeleted
| ManyScopesDeleted
| ScopesPageRequested
| ScopesPageLoaded
| ScopesPageCancelled
| ScopesPageToggleLoading
| ScopeActionToggleLoading;
